<div class="toast-container">
  <div *ngFor="let msg of messages$ | async" class="toast" [ngClass]="msg.type">
    {{ msg.message }}
  </div>
</div>
